import React, { Component, Fragment } from "react";
import InfoBlock from "../presentational/InfoBlock";

class AboutContainer extends Component {
  info = [
    {
      title: "ПРЕДМЕТ НА ДЕЙНОСТ",
      text:
        "Набиране на средства чрез издаване на ценни книжа и покупка на недвижими имоти и вещни права върху недвижими имоти, извършване на строежи и подобрения, с цел предоставянето им за управление, отдаване под наем, лизинг или аренда и/или последващата им продажба."
    },
    {
      title: "КАПИТАЛ И АКЦИИ",
      text:
        "„СЛС Имоти” АДСИЦ е учредено на на 1 август 2007 г. Капиталът на дружеството е в размер на 2 500 000 лева, разпределени в 2 500 000 броя обикновени, поименни, безналични, свободно прехвърляеми акции, всяка от които с право на един глас в общото събрание на акционерите. Акциите на СЛС Имоти АДСИЦ се търгуват на БФБ – София, Алтернативен пазар BaSe, Сегмент за дружества със специална инвестиционна цел. Борсов код – ERQ."
    },
    {
      title: "ОБСЛУЖВАЩО ДРУЖЕСТВО",
      text:
        "Обслужващото дружество, с което „СЛС Имоти” АДСИЦ е сключило договор е „Авто Юнион Пропъртис“ ЕООД, което разполага с екип с богат опит в областта на търговията с недвижими имоти и земеделска земя. Дейността по договора за обслужване се осъществява във връзка с недвижимите имоти, собственост на „СЛС Имоти” АДСИЦ, или в които дружеството възнамерява да инвестира."
    },
    {
      title: "БАНКА-ДЕПОЗИТАР",
      text:
        "Съгласно изискванията на Закона за дружествата със специална инвестиционна цел, активите на „СЛС Имоти” АДСИЦ трябва да се съхраняват от банка-депозитар. Банката-депозитар на „СЛС Имоти” АДСИЦ е „Тексим Банк” АД"
    }
  ];

  render() {
    return (
      <Fragment>
        {this.info.map(({ title, text }) => (
          <InfoBlock key={title} title={title}>
            <p>{text}</p>
          </InfoBlock>
        ))}
      </Fragment>
    );
  }
}

export default AboutContainer;



// WEBPACK FOOTER //
// ./src/containers/About.js